import React from 'react';
import backgroundImage from "../assets/test5.jpg";
import ImageNew from "../assets/images/2new (2).jfif";
import Image2 from "../assets/images/2.jpeg";
import Image3 from "../assets/images/7.jpeg";
import Image4 from "../assets/images/9.jpeg";
import ImageNew2 from "../assets/images/2new (1).jfif";
import PageBanner from "../components/ui/PageBanner";
import useSEO from "../hooks/useSEO";


const About = () => {
    useSEO({
        title: "O mně — Mgr. Šimon Urban, fyzioterapeut | UrbanFyzio",
        description: "Mgr. Šimon Urban — absolvent LF Ostravské univerzity. Specializace na DNS, měkké a mobilizační techniky pro sportovce i běžnou populaci.",
        path: "/o-mne",
    });

    return (
        <div className="flex flex-col bg-surface min-h-screen">
            <PageBanner
                title="O mně"
                subtitle="Poznejte fyzioterapeuta, který se postará o vaše zdraví"
                backgroundImage={backgroundImage}
            />

            <div className="container-narrow section py-16 md:py-24 space-y-20">

                {/* Intro */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16 items-center">
                    <div>
                        <span className="badge-brand mb-4">Fyzioterapeut</span>
                        <h2 className="text-3xl md:text-5xl font-bold text-ink-900 leading-tight">
                            Mgr. Šimon Urban
                        </h2>
                        <span className="accent-bar mt-5" />
                        <p className="mt-6 text-ink-600 text-base md:text-lg leading-relaxed">
                            V rámci fyzioterapie se specializuji na běžnou populaci i vrcholové sportovce.
                            V terapii se zaměřuji především na měkké a mobilizační techniky, které kombinuji
                            s cvičením založeným na principech Dynamické neuromuskulární stabilizace (DNS).
                        </p>
                        <p className="mt-4 text-ink-600 text-base md:text-lg leading-relaxed">
                            Mým cílem je nejen zlepšení vašeho zdraví a pohybového aparátu, ale také prevence
                            zranění a optimalizace výkonu.
                        </p>

                        <div className="mt-8 grid grid-cols-2 gap-4">
                            <Credential label="Magisterské studium" value="LF Ostravské univerzity" />
                            <Credential label="Specializace" value="DNS, měkké techniky" />
                        </div>
                    </div>

                    <div className="relative">
                        <div className="absolute -inset-3 bg-brand-100 rounded-3xl -z-0 -rotate-1" />
                        <div className="relative z-10 w-full aspect-square md:aspect-[4/5] overflow-hidden rounded-2xl shadow-soft-lg">
                            <img
                                src={ImageNew}
                                alt="Mgr. Šimon Urban — fyzioterapeut UrbanFyzio"
                                className="w-full h-full object-cover object-center"
                            />
                        </div>
                    </div>
                </div>

                {/* Gallery */}
                <div>
                    <div className="text-center mb-10">
                        <h3 className="text-2xl md:text-3xl font-semibold text-ink-900">Z naší ambulance</h3>
                        <div className="mt-3 flex justify-center"><span className="accent-bar" /></div>
                    </div>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-5">
                        {[Image2, Image4, Image3, ImageNew2].map((src, i) => (
                            <div key={i} className="overflow-hidden rounded-2xl shadow-soft group">
                                <img
                                    src={src}
                                    alt={`Z ambulance UrbanFyzio Frýdek-Místek — pohled ${i + 1}`}
                                    loading="lazy"
                                    className="w-full aspect-square object-cover transition-transform duration-500 ease-smooth group-hover:scale-105"
                                />
                            </div>
                        ))}
                    </div>
                </div>

                {/* CTA */}
                <div className="card p-8 md:p-12 bg-soft-sky text-center">
                    <h3 className="text-2xl md:text-3xl font-bold text-ink-900">
                        Připraveni začít?
                    </h3>
                    <p className="mt-3 text-ink-600 max-w-xl mx-auto">
                        Rezervujte si první konzultaci a probereme spolu váš stav i možnosti terapie.
                    </p>
                    <div className="mt-6 flex flex-col sm:flex-row gap-3 justify-center">
                        <a
                            href="https://urbanfyzio.reservio.com/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn-primary"
                        >
                            Rezervovat termín
                        </a>
                        <a href="tel:+420734312843" className="btn-outline">
                            +420 734 312 843
                        </a>
                    </div>
                </div>

            </div>
        </div>
    );
};

const Credential = ({ label, value }) => (
    <div className="p-4 rounded-xl border border-ink-100 bg-white">
        <div className="text-xs uppercase tracking-wider text-ink-500 font-semibold">{label}</div>
        <div className="mt-1 text-ink-900 font-medium">{value}</div>
    </div>
);

export default About;
